type Subscriber<T extends {} = {}> = {
  subscribe: (callback: (args: T) => void) => void;
  unsubscribe: (callback: (args: T) => void) => void;
};

type Accessor<T> = {
  get: () => T;
  set: (value: T) => void;
};

type CommonProps = {
  canPlaySound?: boolean;
};

type EvoPlayerUninitialized = CommonProps & {
  initialized?: false;
};

export type EvoPlayerInitialized = CommonProps & {
  initialized: true;
  rawStats: Subscriber<[string, any]>;

  availableQualities: Subscriber<string[]>;
  wallclock: Subscriber<{ wallclock: number }>;
  isUserInteractionRequired: Subscriber;
  stats: Subscriber<[string, any]>;

  container: Accessor<HTMLDivElement>;
  volume: Accessor<number>;
  muted: Accessor<boolean>;
  enableVideo: Accessor<boolean>;
  showInfo: Accessor<boolean>;
  qualityMode: Accessor<'AUTO' | 'MANUAL'>;
  quality: Accessor<string>;
};

export type EvoPlayerInstance = EvoPlayerUninitialized | EvoPlayerInitialized;

export const EvoPlayer: EvoPlayerInstance = {};
